import { gql } from 'graphql-tag'
import { activityWeightFragment } from '../activityWeights/queries'

const ShiftTypeEnum = {
  Morning: 'Morning',
  Evening: 'Evening',
  Night: 'Night',
}

const salesIncentiveProductFragment = gql`
  fragment SalesIncentiveProductFragment on SalesIncentiveProduct {
    id
    name
    isEnabled
    price
    category
    ean
    sokId
    cdtPath
  }
`

const incentiveSalesTargetFragment = gql`
  fragment IncentiveSalesTargetFragment on IncentiveSalesTarget {
    year
    incentiveSalesTarget
    shiftPercentages {
      ${ShiftTypeEnum.Morning}
      ${ShiftTypeEnum.Evening}
      ${ShiftTypeEnum.Night}
    }
    monthlyTargets {
      month
      year
      incentiveSalesTarget
    }
  }
`

export const salesIncentiveProductsQuery = gql`
  query SalesIncentiveProducts {
    salesIncentiveProducts {
      ...SalesIncentiveProductFragment
    }
  }
  ${salesIncentiveProductFragment}
`
export const fetchStationSalesIncentiveProducts = gql`
  query FetchStationSalesIncentiveProducts(
    $stationId: ID!
    $date: String!
    $nextYearDate: String!
    $currentYear: Int!
    $lastYear: Int!
  ) {
    incentiveSalesTarget(stationId: $stationId, date: $date) {
      ...IncentiveSalesTargetFragment
    }
    incentiveSalesTargetNextYear: incentiveSalesTarget(stationId: $stationId, date: $nextYearDate) {
      ...IncentiveSalesTargetFragment
    }
    incentiveSalesLastYear: monthlyIncentiveSalesByYear(stationId: $stationId, year: $lastYear) {
      month
      year
      totalIncentiveSales
    }
    incentiveSalesCurrentYear: monthlyIncentiveSalesByYear(stationId: $stationId, year: $currentYear) {
      month
      year
      totalIncentiveSales
    }
    activityWeights(stationId: $stationId, type: "incentive_sales") {
      ...ActivityWeightFragment
    }
    stationSalesIncentiveProducts(stationId: $stationId) {
      ...SalesIncentiveProductFragment
    }
  }
  ${salesIncentiveProductFragment}
  ${activityWeightFragment}
  ${incentiveSalesTargetFragment}
`

export const upsertIncentiveSalesTargetMutation = gql`
  mutation UpsertIncentiveSalesTarget($stationId: ID!, $data: CreateIncentiveSalesTargetInput!) {
    upsertIncentiveSalesTarget(stationId: $stationId, data: $data) {
      ...IncentiveSalesTargetFragment
    }
  }
  ${incentiveSalesTargetFragment}
`

export const createSalesIncentiveProductMutation = gql`
  mutation CreateSalesIncentiveProduct(
    $name: String!
    $isEnabled: Boolean
    $stationId: ID
    $price: Float!
    $category: String!
  ) {
    createSalesIncentiveProduct(
      name: $name
      isEnabled: $isEnabled
      stationId: $stationId
      price: $price
      category: $category
    ) {
      ...SalesIncentiveProductFragment
    }
  }
  ${salesIncentiveProductFragment}
`

export const updateSalesIncentiveProductMutation = gql`
  mutation UpdateSalesIncentiveProduct(
    $id: ID!
    $name: String!
    $isEnabled: Boolean
    $price: Float!
    $category: String
  ) {
    updateSalesIncentiveProduct(
      salesIncentiveProductId: $id
      name: $name
      isEnabled: $isEnabled
      price: $price
      category: $category
    ) {
      ...SalesIncentiveProductFragment
    }
  }
  ${salesIncentiveProductFragment}
`

export const deleteSalesIncentiveProductMutation = gql`
  mutation DeleteSalesIncentiveProduct($id: ID!) {
    deleteSalesIncentiveProduct(salesIncentiveProductId: $id)
  }
`

export const getMonthlyTargetsByBudget = gql`
  query MonthlyTargetsByBudget($stationId: ID!, $year: Int!, $yearlyTarget: Float!) {
    monthlyTargetsByBudget(stationId: $stationId, year: $year, yearlyTarget: $yearlyTarget) {
      month
      year
      incentiveSalesTarget
    }
  }
`
